import React, { useEffect, useState } from "react";
import { Icon } from "@iconify/react";

export default function SelectStepModal({
  isOpen,
  onClose,
  serviceData,      // { Service_Id, Service_Name, Steps: [...] }
  onSave,           // ส่ง Step ที่เลือกกลับไป
}) {

  const [selected, setSelected] = useState({});

  useEffect(() => {
    if (isOpen && serviceData) {
      const init = {};
      const selectedStepIds = serviceData.selectedStepIds || new Set();
      
      serviceData.Steps.forEach((st) => {
        // ถูกเลือกอยู่แล้ว → checked | เป็น default → checked | อื่นๆ → unchecked
        init[st.Step_Id] = selectedStepIds.has(st.Step_Id) || st.IsDefault === 1;
      });
      setSelected(init);
    }
  }, [isOpen, serviceData]);

  if (!isOpen || !serviceData) return null;

  return (
    <div className="fixed inset-0 z-[99999] bg-black/40 flex justify-center items-center">
      <div className="bg-white w-auto min-w-[600px] max-w-[95vw] max-h-[85vh] rounded-xl shadow-xl overflow-hidden">
        
        {/* HEADER */}
        <div className="p-3 bg-[#E13F57] text-white flex justify-between items-center">
          <h3 className="font-bold text-lg">
            เพิ่มขั้นตอนบริการ: {serviceData.Service_Name}
          </h3>
          <button onClick={onClose} className="text-2xl px-2">×</button>
        </div>

        {/* BODY */}
        <div className="p-3 overflow-y-auto max-h-[60vh]">
          {serviceData.Steps && serviceData.Steps.length > 0 ? (
            serviceData.Steps.map((st) => {
              const selectedStepIds = serviceData.selectedStepIds || new Set();
              const isAlreadySelected = selectedStepIds.has(st.Step_Id);
              const isChecked = selected[st.Step_Id] || false;
              
              return (
                <label 
                  key={st.Step_Id} 
                  className={`flex items-center gap-3 py-2 px-2 ${
                    isAlreadySelected 
                      ? "cursor-not-allowed opacity-60" 
                      : "hover:bg-gray-50 cursor-pointer"
                  }`}
                >
                  <input
                    type="checkbox"
                    checked={isChecked}
                    disabled={isAlreadySelected}
                    onChange={(e) => {
                      if (!isAlreadySelected) {
                        setSelected((p) => ({ ...p, [st.Step_Id]: e.target.checked }));
                      }
                    }}
                    className="w-5 h-5 accent-[#E13F57]"
                  />
                  <div className="flex-1 flex items-center gap-2 min-w-0">
                    <span className="flex-1 whitespace-nowrap">{st.Step_Title}</span>
                    <div className="flex items-center gap-2 flex-shrink-0">
                      {st.IsDefault === 1 && (
                        <span className="text-xs bg-blue-100 text-blue-700 px-2 py-0.5 rounded whitespace-nowrap">
                          ค่าเริ่มต้น
                        </span>
                      )}
                      {isAlreadySelected && (
                        <span className="text-xs bg-gray-200 text-gray-600 px-2 py-0.5 rounded whitespace-nowrap">
                          ถูกเลือกแล้ว
                        </span>
                      )}
                    </div>
                  </div>
                </label>
              );
            })
          ) : (
            <div className="text-center text-gray-400 py-4">
              ไม่มีขั้นตอนการบริการ
            </div>
          )}
        </div>

        {/* FOOTER */}
        <div className="p-3 border-t flex justify-end gap-2">
          <button
            className="px-4 py-2 bg-gray-200 rounded-md"
            onClick={onClose}
          >
            ยกเลิก
          </button>

          <button
            onClick={() => {
              const selectedStepIds = serviceData.selectedStepIds || new Set();
              // กรองเฉพาะ steps ที่ถูกเลือกใหม่ (ไม่รวม steps ที่ถูกเลือกอยู่แล้ว)
              const list = serviceData.Steps.filter(
                (s) => selected[s.Step_Id] && !selectedStepIds.has(s.Step_Id)
              );
              
              if (list.length === 0) {
                // No new steps selected, just close
                onClose();
                return;
              }
              
              // Call onSave to add steps (no save to API here)
              onSave(list);  // ส่ง steps ที่ติ๊กเลือกใหม่กลับไป
              onClose();  // Close modal after selecting
            }}
            className="px-4 py-2 bg-[#E13F57] text-white rounded-md"
          >
            เลือก
          </button>
        </div>
      </div>
    </div>
  );
}
